export default {
  title: 'Rozpocznij',
  description: 'Aby załadować tę stronę, musisz ukończyć przewodnik Rozpocznij',
  button: 'Rozpocznij',
};
